<template>
  <div class="w-full h-full flex flex-col bg-backgroundColor">
    <div class="text-center pt-16">
      <p class="text-seconary uppercase text-sm">Connect with us</p>
      <h3 class="text-3xl pt-3 font-semibold capitalize">Let us hear from you.</h3>
    </div>

    <div class="w-full h-full flex flex-col items-center">
      <div class="w-[94%] md:w-[75%] 2xl:w-[60%] flex flex-col md:flex-row md:justify-between pt-5 md:pt-16">

        <div class="w-full pr-5">
          <h2 class="text-3xl pt-3 font-semibold">Get in touch with us.</h2>
          <p class="pt-3">
            We’d love to hear from you. Fill out the form below and we’ll get back to you soon.
          </p>
        </div>

        <!-- FORM -->
        <div class="w-full bg-white rounded-md mt-5 md:mt-0 p-5">
          <form @submit.prevent="submitForm">
            <div class="mb-4">
              <label class="block mb-1">Full Name <span class="text-red">*</span></label>
              <input v-model="form.fullName" type="text" class="w-full p-2 border rounded" required />
            </div>

            <div class="mb-4">
              <label class="block mb-1">Phone Number <span class="text-red">*</span></label>
              <input v-model="form.phone" type="tel" class="w-full p-2 border rounded" required />
            </div>

            <div class="mb-4">
              <label class="block mb-1">Email Address <span class="text-red">*</span></label>
              <input v-model="form.email" type="email" class="w-full p-2 border rounded" required />
            </div>

            <div class="mb-4">
              <label class="block mb-1">Message <span class="text-red">*</span></label>
              <textarea v-model="form.message" class="w-full p-2 border rounded" rows="4" required></textarea>
            </div>

            <button type="submit" class="bg-mainColor text-white px-4 py-2 rounded hover:bg-blue-700">
              Submit
            </button>
          </form>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import { db } from "@/firebaseConfig";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";

export default {
  name: "ContactUsPage",

  data() {
    return {
      form: {
        fullName: "",
        phone: "",
        email: "",
        message: "",
      },
      loading: false,
    };
  },

  methods: {
    async submitForm() {
  try {
    await addDoc(collection(db, "contactMessages"), {
      fullName: this.form.fullName,
      phone: this.form.phone,
      email: this.form.email,
      message: this.form.message,
      createdAt: serverTimestamp(),
    });

    alert("Message received! We will contact you soon.");
    this.form = { fullName: "", phone: "", email: "", message: "" };
  } catch (error) {
    alert("Failed: " + error.message);
  }
}

  },
};
</script>
